import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

// tslint:disable-next-line: no-any
export default (initialState: any) =>
  createStore(reducers, initialState, applyMiddleware(thunk));
